/// <amd-module name="Artifacts/Feed/types/ProblemPackageItem" />
export class ProblemPackageItem {
  protocolId: string;
  packageName: string;
  packageVersion: string;
  sourceName: string;
  status: string; // problempackage.problempackagereason.code
  description: string; // problempackage.problempackagereason.message
  failedDate: Date;
}
